import React, { useState } from 'react';

const sectionsData = [
  {
    title: 'Ауторске представе:',
    items: [
      "Чаролија на крају представе", "Велика морска авантура", "Потрага за благом", "Принцеза и жабац",
      "Успавана Ружица", "Тајна чаробног кофера - иза кулиса", "Аска и вук", "Велики бал",
      "Једном ја тако...", "Снежна краљица"
    ]
  },
  {
    title: 'Копродукција:',
    items: [
      "Био једном један Моцарт (ЦКО Раковица)",
      "Музички времеплов Бетовена и Елизе (ЦКО Раковица)",
      "Царево ново одело (ЦКО Раковица)",
      "Чистологија (ПАБ Склониште у Театру)",
      "Ах, та Црвенкапа (Балканска група АРА)"
    ]
  },
  {
    title: 'Представе које су се играле некада давно:',
    items: ["Весели Индијанци", "Медина дијета", "Шумска школа"]
  },
  {
    title: 'У припреми:',
    items: ["Нушићева вртешка", "Капетан који кука", "Мачак у чизмама"]
  },
  {
    title: 'Новогодишње представе:',
    items: [
      "Деда Мраз на путу око света", "Под сјајем новогодишњих звезда",
      "Деда Мраз и патуљци у невољи", "Деда Мраз на годишњем одмору"
    ]
  }
];

const RepertoarSection = () => {
  return (
    <div className="repertoar-container">
      {sectionsData.map((section, index) => (
        <AccordionSection key={index} title={section.title} items={section.items} />
      ))}
    </div>
  );
};

const AccordionSection = ({ title, items }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="section">
      <button className="section-header" onClick={() => setIsOpen(!isOpen)}>
        <span>{title}</span>
        <span className="arrow">{isOpen ? '−' : '+'}</span>
      </button>
      {isOpen && (
        <ul className="section-list">
          {items.map((item, index) => (
            <li key={index}>
              <span className="bullet"></span>
              <span className="text">{item}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default RepertoarSection;
